/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import TimelineHistory from '../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getGetchkdUserHistory } from '../../../../../../store/reducers/getchkdUser/getchkdUserAction';
import { useDispatch, useSelector } from 'react-redux';
const GetchkdHistory = ({ selectedGetchkdUser }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch()
    const getchkdUserHistory = useSelector(state => state.getchkdUser.getchkdUserHistory)
    useEffect(() => {
        dispatch(getGetchkdUserHistory({ "getChkdID": selectedGetchkdUser.getChkdID }))
    }, [dispatch, selectedGetchkdUser]);
    useEffect(() => {
        setHistoryList([])
        if (getchkdUserHistory?.length > 0) {
            getchkdUserHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        ...element.Record,
                        name: element.Record.getChkdID,
                        details: element.Record.accountDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }])
            });
        }
    }, [historyList, getchkdUserHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light">User  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}

export default GetchkdHistory;
